import { createFilterOptions } from '@material-ui/lab/useAutocomplete';
import _ from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import QCXAutocompleteSelect from '../autocomplete-select/QCXAutocompleteSelect';

import { fetchAllOperatorsAsync } from '../../features/follow-up/followUpThunks';

import { selectConfigControl, selectFollowUps } from '../../features/follow-up/followUpSelectors';
import { isAutoLoadControl } from '../../utils/store/store-utils';

export default function QCXSelectFollowUpAutocompleteField({ label, name, disabled: userDisabled, lockSelect=false, initialValues, ...restProps }) {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const prevIdRef = React.useRef(null);

  const [defaultValue, setDefaultValue] = useState('');
  const [filteredFollowUpsActive, setFilteredFollowUpsActive] = useState([]);
  const [internalLoading, setInternalLoading] = useState(true);

  const list = useSelector(selectFollowUps);
  const configControl = useSelector(selectConfigControl);

  useEffect(() => {
    if (!_.isEmpty(list)) {
      _.debounce(() => setInternalLoading(false), 2000)();
    }
  }, [list]);

  useEffect(() => {
    if (isAutoLoadControl(configControl)) {
      dispatch(fetchAllOperatorsAsync());
    }
  }, [configControl]);

  useEffect(() => {
    const filterFollowUpsActive = list.filter((item) => item?.active && item?.numero);

    if (filterFollowUpsActive) {
      setFilteredFollowUpsActive(filterFollowUpsActive);
    }
  }, [list, setFilteredFollowUpsActive]);

  useEffect(() => {
    const newId = _.get(initialValues, name);   // id que vem do formulário
    if (newId === prevIdRef.current) return;    
    prevIdRef.current = newId;

    const value = list.find((item) => item?.id === newId)
      || { id: null, description: '' };
    setDefaultValue(value);
  }, [list, initialValues]);

  const filterOptions = createFilterOptions({
    stringify: (item) => item?.numero,
  });

  const isDisabled = internalLoading || userDisabled;
  // impedir abertura caso lockSelect ou disabled
  const preventOpen = lockSelect || isDisabled;

  return (
    <QCXAutocompleteSelect
      label={label}
      id={name}
      name={name}
      options={filteredFollowUpsActive}
      filterOptions={filterOptions}
      defaultValue={defaultValue}
      getOptionLabel={(item) => item?.numero || ''}
      {...restProps}
      placeholder={internalLoading ? 'BUSCANDO FOLLOWUPS' : 'SELECIONE UM FOLLLOWUP'}
      loading={internalLoading}
      loadingText={t('com.muralis.qcx.carregando')}
      disabled={isDisabled}
      open={preventOpen ? false : undefined}
      disableClearable={preventOpen}
    />
  );
}
